var colorboxDisableTouchmove = function (e) {
  e.preventDefault();
  return false;
};

function isColorboxIframe(node) {
  return node
    .getAttribute('href')
    .match(/(youtube\.com|youtube-nocookie\.com|youtu\.be|vimeo\.com)/i);
}

var colorboxConf = {
  className: function () {
    return isColorboxIframe(this) ? 'colorbox-with-iframe' : '';
  },
  title: function () {
    if (jQuery(this).children('img').length) {
      return jQuery(this).parent().children('figcaption').text();
    }
    var title = jQuery(this).data('title');
    if (typeof title !== 'undefined') {
      return title;
    }
    return '';
  },
  iframe: function () {
    return isColorboxIframe(this);
  },
  innerWidth: function () {
    if (isColorboxIframe(this)) {
      return '100%';
    }
    return null;
  },
  // Support srcset and sizes
  createImg: function () {
    var img = new Image();
    var data = jQuery(this).data();
    var attrs = data['cbox-img-attrs'];

    if (typeof attrs === 'object') {
      jQuery.each(attrs, function (key, val) {
        img[key] = val;
      });
    }

    if (typeof data.srcset !== 'undefined') {
      img.srcset = data.srcset;
    }

    if (typeof data.sizes !== 'undefined') {
      img.sizes = data.sizes;
    }

    return img;
  },
  innerHeight: function () {
    if (isColorboxIframe(this)) {
      // We need to maintain the ratio for WLC videos, most importantly on mobile
      var maxHeight = window.innerHeight * 1;

      // Adjust to the site we use in the innerWidth callback
      var height = window.innerWidth * 1;
      // Apply 16/9 ratio to the size of the frame
      height = (height / 16) * 9;

      return (height > maxHeight ? maxHeight : height) + 'px';
    }
    return null;
  },
  maxWidth: '100%',
  maxHeight: '100%',
  height: '100%',
  width: '100%',
  next: '',
  previous: '',
  close: '',
  fixed: true,
  returnFocus: false,
  current: '{current} / {total}',
  rel: function (colorboxObj) {
    var $gallery = jQuery(this).closest('.gallery');
    if ($gallery.length) {
      return $gallery.attr('id');
    }
    var rel = jQuery(this).attr('rel');
    if (rel) {
      return rel;
    }
    return 'group';
  },
  opacity: 0.95,
  onOpen: function () {
    jQuery('html').addClass('colorbox-popup-on');
    jQuery(document).bind('touchmove', colorboxDisableTouchmove);
  },
  onClosed: function () {
    jQuery('html').removeClass('colorbox-popup-on');
    jQuery(document).unbind('touchmove', colorboxDisableTouchmove);
  },
};

(function ($) {
  function initializeColorBox() {
    $(
      '.entry-content a:not([target=_blank]), a.colorbox, .widget_media_gallery .gallery-item a, .widget_media_image a, body.page-template-template-video-archive a.entry-thumbnail'
    )
      .filter(function () {
        var attribute = $(this).attr('href');
        if (
          typeof attribute === 'undefined' ||
          $(this).hasClass('colorbox-initialized')
        ) {
          return false;
        }
        return attribute.match(
          /(\.(jpg|jpeg|png|gif|webp)$)|(youtube\.com|youtube-nocookie\.com|youtu\.be|vimeo\.com)/i
        );
      })
      .addClass('colorbox-initialized')
      .colorbox(colorboxConf);
  }

  $(document).ready(function () {
    initializeColorBox();
  });

  $(document).on('ajaxPostsLoaded', function (e) {
    initializeColorBox();
  });

  $(document).on('click', '#cboxLoadedContent', function (e) {
    if (e.target.getAttribute('id') === 'cboxLoadedContent') {
      $(e.target).nextAll('#cboxClose').click();
    }
  });
})(jQuery);
